import { render, staticRenderFns } from "./inviteSend.vue?vue&type=template&id=6daef8b2&"
import script from "./inviteSend.vue?vue&type=script&lang=js&"
export * from "./inviteSend.vue?vue&type=script&lang=js&"
import style0 from "./inviteSend.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports